import { render, staticRenderFns } from "./AdditionPhoneList.vue?vue&type=template&id=75c25589&scoped=true&"
import script from "./AdditionPhoneList.vue?vue&type=script&lang=js&"
export * from "./AdditionPhoneList.vue?vue&type=script&lang=js&"
import style0 from "./AdditionPhoneList.vue?vue&type=style&index=0&id=75c25589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c25589",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VMenu,VRow})
